const createSellerMutation = `
  mutation CreateMarketplaceSeller($fields: CreateMarketplace_sellerFieldsInput) {
    createMarketplace_seller(input: { fields: $fields }) {
      marketplace_seller {
        objectId
        name
        phone
        enabled
        public
        b2b
        b2c
        public_prices
        ask_for_info
        createdAt
        updatedAt
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default createSellerMutation;
